import { useEffect, useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Static fallback so nav/sidebar render instantly before the fetch lands.
export const DEFAULT_CATEGORIES = [
  { slug: "bacteriostatic-water", name: "Bacteriostatic Water" },
  { slug: "weight-loss", name: "Weight Loss & Insulin Resistance" },
  { slug: "repair-recovery", name: "Repair & Recovery" },
  { slug: "anti-aging", name: "Anti-aging & Skin care" },
];

let _cache = null;

export function useCategories() {
  const [cats, setCats] = useState(_cache || DEFAULT_CATEGORIES);
  useEffect(() => {
    if (_cache) return;
    fetch(`${API}/categories`)
      .then((r) => r.json())
      .then((d) => {
        if (d?.categories?.length) {
          _cache = d.categories;
          setCats(d.categories);
        }
      })
      .catch(() => {});
  }, []);
  return cats;
}
